import * as React from 'react';
import {SVGProps} from 'react';
const PlusSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg width={18} height={18} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M14.25 8.25h-4.5v-4.5a.75.75 0 1 0-1.5 0v4.5h-4.5a.75.75 0 1 0 0 1.5h4.5v4.5a.75.75 0 1 0 1.5 0v-4.5h4.5a.75.75 0 1 0 0-1.5Z" />
    <mask
      id="a"
      style={{
        maskType: 'alpha',
      }}
      maskUnits="userSpaceOnUse"
      x={3}
      y={3}
      width={12}
      height={12}
    >
      <path d="M14.25 8.25h-4.5v-4.5a.75.75 0 1 0-1.5 0v4.5h-4.5a.75.75 0 1 0 0 1.5h4.5v4.5a.75.75 0 1 0 1.5 0v-4.5h4.5a.75.75 0 1 0 0-1.5Z" />
    </mask>
  </svg>
);
export default PlusSvg;
